(() => {
  // app/scripts/common/section/related-products.js
  var RelatedProducts = {
    onLoad() {
      let { container } = this;
      try {
        AT.detectVisible({
          element: container,
          rootMargin: "0px",
          callback: () => {
            let sliderComponent = container.querySelector("slider-component");
            sliderComponent.init();
          }
        });
      } catch (error) {
        console.log(container);
        console.error(error);
      }
    }
  };

  // app/scripts/common/function/linkOptions.js
  var linkOptions = (container, product, cb) => {
    let optionsMap = {};
    if (!container) {
      return;
    }
    let statusWhenVariantSoldOut = container.dataset.statusSoldOut;
    let optionElements = container.getElementsByClassName("js-option-item");
    if (product.variants.length < 2) {
      return;
    }
    optionElements.addEvents("change", function() {
      container.dispatchEvent(new CustomEvent("swatch-change", { detail: { position: +this.dataset.optionPosition, optionValue: this.value } }));
    });
    container.addEvent("swatch-change", function({ detail: { position, optionValue } }) {
      container.querySelector(`[data-selected-option='option${position}']`).innerHTML = optionValue;
      switch (position) {
        case 1:
          if (product.options.length > 1) {
            updateOptionsInSelector(2);
          } else {
            cb(findVariantFromOption(getValueOptions()));
          }
          break;
        case 2:
          if (product.options.length === 3) {
            updateOptionsInSelector(3);
          } else {
            cb(findVariantFromOption(getValueOptions()));
          }
          break;
        case 3:
          cb(findVariantFromOption(getValueOptions()));
          break;
      }
    });
    product.variants.forEach((variant) => {
      if (variant.available) {
        optionsMap["root"] = optionsMap["root"] || [];
        optionsMap["root"].push(variant.option1);
        optionsMap["root"] = optionsMap["root"].reduce((accu, currentvalue) => {
          if (!accu.includes(currentvalue)) {
            accu.push(currentvalue);
          }
          return accu;
        }, []);
        if (product.options.length > 1) {
          var key = variant.option1;
          optionsMap[key] = optionsMap[key] || [];
          optionsMap[key].push(variant.option2);
          optionsMap[key] = optionsMap[key].reduce((accu, currentvalue) => {
            if (!accu.includes(currentvalue)) {
              accu.push(currentvalue);
            }
            return accu;
          }, []);
        }
        if (product.options.length === 3) {
          var key = variant.option1 + " / " + variant.option2;
          optionsMap[key] = optionsMap[key] || [];
          optionsMap[key].push(variant.option3);
          optionsMap[key] = optionsMap[key].reduce((accu, currentvalue) => {
            if (!accu.includes(currentvalue)) {
              accu.push(currentvalue);
            }
            return accu;
          }, []);
        }
      }
    });
    updateOptionsInSelector(1);
    function updateOptionsInSelector(position) {
      let optionValues = getValueOptions();
      let key, selector;
      switch (position) {
        case 1:
          key = "root";
          selector = container.querySelector(".js-swatch-item[data-position='1']");
          break;
        case 2:
          key = optionValues.option1;
          selector = container.querySelector(".js-swatch-item[data-position='2']");
          break;
        case 3:
          key = optionValues.option1 + " / " + optionValues.option2;
          selector = container.querySelector(".js-swatch-item[data-position='3']");
          break;
      }
      switch (selector.dataset.style) {
        case "select": {
          let selectElement = selector.getElementsByClassName("js-option-item")[0];
          let oldValue2 = selectElement.value;
          switch (statusWhenVariantSoldOut) {
            case "hide": {
              selectElement.innerHTML = optionsMap[key].map((optionValue) => `<option value="${optionValue}">${optionValue}</option>`).join("");
              if (optionsMap[key].includes(oldValue2)) {
                selectElement.value = oldValue2;
              }
              break;
            }
            case "disable": {
              [...selectElement.options].forEach((option) => {
                if (optionsMap[key].includes(option.value)) {
                  option.disabled = false;
                } else {
                  option.disabled = true;
                  option.selected = false;
                }
              });
              [...selectElement.options].find((option) => option.disabled == false && (option.selected = true));
              break;
            }
          }
          break;
        }
        case "color":
        case "image":
        case "button":
          let inputsElement = selector.getElementsByClassName("js-option-item");
          let oldValue = [...inputsElement].find((input) => input.checked).value;
          switch (statusWhenVariantSoldOut) {
            case "hide":
              inputsElement.forEach((input) => {
                if (optionsMap[key].includes(input.value)) {
                  input.closest(".swatch-group_wrapper").removeClass("d-none");
                } else {
                  input.closest(".swatch-group_wrapper").addClass("d-none");
                  oldValue === input.value && (input.checked = false, inputsElement[0].checked = true);
                }
              });
              break;
            case "disable": {
              inputsElement.forEach((input) => {
                if (optionsMap[key].includes(input.value)) {
                  input.disabled = false;
                } else {
                  input.disabled = true;
                  oldValue === input.value && (input.checked = false, inputsElement[0].checked = true);
                }
              });
              break;
            }
          }
          break;
      }
      container.dispatchEvent(new CustomEvent("swatch-change", { detail: { position, optionValue: optionValues[`option${position}`] } }));
    }
    function getValueOptions() {
      return [...container.getElementsByClassName("js-swatch-item")].reduce((accu, element) => {
        switch (element.dataset.style) {
          case "select":
            let select = element.querySelector("select.single-option-selector");
            accu[select.name] = select.value;
            break;
          case "color":
          case "image":
          case "button":
            let inputsElements = element.querySelectorAll("input[data-single-option-selector]");
            accu[inputsElements[0].name] = [...inputsElements].find((input) => input.checked).value;
            break;
        }
        return accu;
      }, {});
    }
    function findVariantFromOption(options) {
        return product.variants.find((variant) => {
          const variantValue = Object.keys(options).every((optionKey) => variant[optionKey] === options[optionKey]); // This has changed
          console.log(variantValue); // This has changed
          return variantValue; // This has changed
        });
      }
  };

  // app/scripts/common/function/initTabPanel.js
  var initTabPanel = (container) => {
    try {
      let tabControls = container.querySelector(".js-tab-controls");
      let tabContents = container.querySelector(".js-tab-contents");
      [...tabControls.children].forEach((item) => {
        let target = tabContents.querySelector(item.dataset.target);
        item.addEvent("click", () => {
          if (item.hasClass("active")) {
            return;
          }
          tabControls.children.removeClass("active");
          tabContents.children.removeClass("active");
          item.addClass("active");
          target.addClass("active");
        });
      });
    } catch (error) {
      console.warn("Has an error from Tab Panel function:", error);
      console.log(container);
    }
  };

  // app/scripts/common/section/product-default.js
  var ProductDefault = {
    onLoad: function() {
      let container = this.container;
      this.product = theme.product;
      this.elms = {
        priceCompareElement: container.querySelector(".js-price-compare"),
        priceElement: container.querySelector(".js-price"),
        skuElement: container.querySelector(".js-sku"),
        inventoryElement: container.querySelector(".js-inventory"),
        mediaMain: document.getElementById("product-media-main"),
        mediaThumnails: document.getElementById("product-media-thumnails"),
        selectMaster: container.querySelector("#select-master"),
        addToCartButton: container.querySelector(".js-atc-btn"),
        formElement: container.querySelector("form[action*='/cart/add']"),
        labelSaveContainer: container.querySelector(".js-product-label-save"),
        swatchContainer: container.querySelector("swatch-component"),
        findStoreButton: container.querySelector(".js-find-store-btn"),
        quantityInputContainer: container.querySelector(".js-product-quantity"),
        subscribeForm: container.querySelector("#contact-notify-when-available"),
        dynamicCheckoutContainer: container.querySelector(".js-product-dymanic-checkout")
      };
      this.settings = JSON.parse(this.container.querySelector("[data-settings]").innerHTML);
      let shippingTime = document.querySelector(".shipping-time");
      if (shippingTime) {
        this.initOrderDeadLine();
        this.initOrderShipping();
      }
      let checkbundledAddToCart = document.querySelector("#bundledAddToCart");
      if (checkbundledAddToCart) {
        this.initProductItemEvents();
        this.initMultiVariantEvents();
      }

      this.initSliderMedia();
      this.initInventory();
      this.initFormAddToCart();
      linkOptions(this.elms.swatchContainer, this.product, this.handleVariantChange.bind(this));
      this.initScrollToReviews();
      initTabPanel(container);
      if (AT.getParameterByName("contact_posted")) {
        this.switchVariantById(AT.cookie.get("subscribe-variant-id"));
        AT.cookie.delete("subscribe-variant-id");
        let searchParams = window.location.search.replace("?", "").split("&").filter((param) => !param.includes("contact_posted")).filter(Boolean).join("&");
        window.history.replaceState({}, "", `${window.location.pathname}?${searchParams}`);
      }

      if (!this.currentVariant) {
        const initialVariantId = this.elms.selectMaster?.value || AT.getParameterByName("variant") || this.product?.variants?.[0]?.id;
        if (initialVariantId) loadAvailability(initialVariantId);
      }
    },
    initProductItemEvents() {
      let productItemElements = document.querySelectorAll(".js-input-quantity");
      this.initAddToCartFormEvent();
    },
    initAddToCartFormEvent(element) {
      let form = document.querySelector(".js-bundledAddToCart");
      let submitButton = form.querySelector(".js-btn-add-to-cart");
      form.addEvent("submit", (e) => {
        e.preventDefault();
        let inputElements = form.querySelectorAll("input[name='quantity']");
        let items = [...inputElements].reduce((accu, input) => {
          if (+input.value > 0) {
            accu.push({ id: +input.dataset.variantId, quantity: +input.value });
          }
          return accu;
        }, []);
        if (items.length) {
          if (!submitButton.hasClass("has-pending")) {
            submitButton.insertAdjacentHTML("beforeend", '<svg class="svg-loading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; shape-rendering: auto;" width="28px" height="28px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" fill="none" stroke="var(--main-color)" stroke-width="5" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">  <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform></circle></svg>');
          }
          submitButton.addClass("pending", "has-pending");
          Cart.addMutiple(items).then((data) => {
          }).finally(() => {
            submitButton.removeClass("pending");
            window.location.href = "/cart";
          });
        }
      });
    },
    initMultiVariantEvents() {
      let selectMaster = document.querySelectorAll(".select-master-bundle");
      let bundledCheckbox = document.querySelectorAll(".bundled-checkbox");
      let totalBundledPriceHtml = document.querySelector(".js-bundled-total-price");
      let totalBundledPrice = Number(document.querySelector(".bundled-total-price").getAttribute("data-bundled-total-price"));
      bundledCheckbox.forEach(function(button) {
        button.addEventListener("change", function() {
          let bundled_item = this.closest(".bundled-item");
          let bundled_item_qty_id = this.getAttribute("data-id");
          let bundled_item_price = Number(this.getAttribute("data-price"));
          if (this.checked) {
            totalBundledPrice = totalBundledPrice + bundled_item_price;
            bundled_item.querySelector(".js-input-quantity").value = "1";
            document.querySelector("#" + bundled_item_qty_id).removeClass("d-none");
            if (bundled_item.querySelector(".select-group-bundle").hasClass("select-multi-variants")) {
              bundled_item.querySelector(".select-group-bundle").removeClass("d-none");
            }
          } else {
            totalBundledPrice = totalBundledPrice - bundled_item_price;
            bundled_item.querySelector(".js-input-quantity").value = "0";
            document.querySelector("#" + bundled_item_qty_id).addClass("d-none");
            if (bundled_item.querySelector(".select-group-bundle").hasClass("select-multi-variants")) {
              bundled_item.querySelector(".select-group-bundle").addClass("d-none");
            }
          }
          totalBundledPriceHtml.innerHTML = totalBundledPrice.toCurrency();
          document.querySelector(".bundled-total-price").setAttribute("data-bundled-total-price", totalBundledPrice);
          totalBundledPrice = Number(document.querySelector(".bundled-total-price").getAttribute("data-bundled-total-price"));
        });
      });
      selectMaster.forEach(function(select) {
        select.addEventListener("change", function() {
          let selectid = this.getAttribute("id");
          let bundled_item = this.closest(".bundled-item");
          let select_option_price = Number(this.options[this.selectedIndex].getAttribute("data-option-price"));
          let select_option_data_price = Number(bundled_item.querySelector(".bundled-checkbox").setAttribute("data-price", select_option_price));
          bundled_item.querySelector(".js-input-quantity").setAttribute("id", this.value);
          bundled_item.querySelector(".js-input-quantity").setAttribute("data-variant-id", this.value);
          document.querySelector("." + selectid).innerHTML = select_option_price.toCurrency();
          let totalBundledPriceSelect = 0;
          let bundledCheckbox2 = document.querySelectorAll(".bundled-checkbox");
          bundledCheckbox2.forEach(function(button) {
            if (button.checked) {
              let bundled_item_price = Number(button.getAttribute("data-price"));
              totalBundledPriceSelect = totalBundledPriceSelect + bundled_item_price;
            }
          });
          totalBundledPriceHtml.innerHTML = totalBundledPriceSelect.toCurrency();
          document.querySelector(".bundled-total-price").setAttribute("data-bundled-total-price", totalBundledPriceSelect);
          totalBundledPrice = Number(document.querySelector(".bundled-total-price").getAttribute("data-bundled-total-price"));
        });
      });
    },
    initOrderDeadLine() {
      let _deadline_time = parseInt(document.querySelector(".shipping-time").getAttribute("data-deadline"));
      let _deadline_html = document.querySelector(".deadline");
      let _currentDate = new Date();
      let _dueDate = new Date(_currentDate.getFullYear(), _currentDate.getMonth(), _currentDate.getDate());
      _dueDate.setHours(_deadline_time);
      if (_currentDate >= _dueDate) {
        _deadline_html.innerHTML = theme.strings.product.order_until + " <strong>" + _deadline_time + ":00 " + theme.strings.product.tomorrow + "</strong>";
      } else {
        _deadline_html.innerHTML = theme.strings.product.order_today_until + " <strong>" + _deadline_time + ":00</strong>";
      }
    },
    initOrderShipping() {
      let today = new Date();
      let business_days = parseInt(document.querySelector(".shipping-time").getAttribute("data-deliverytime"));
      let deliveryDate = today;
      let total_days = business_days;
      for (let days = 1; days <= total_days; days++) {
        deliveryDate = new Date(today.getTime() + days * 24 * 60 * 60 * 1e3);
        if (deliveryDate.getDay() == 0 || deliveryDate.getDay() == 6) {
          total_days++;
        }
      }
      let weekday = new Array(7);
      weekday[0] = theme.strings.date_formats.sunday;
      weekday[1] = theme.strings.date_formats.monday;
      weekday[2] = theme.strings.date_formats.tuesday;
      weekday[3] = theme.strings.date_formats.wednesday;
      weekday[4] = theme.strings.date_formats.thursday;
      weekday[5] = theme.strings.date_formats.friday;
      weekday[6] = theme.strings.date_formats.saturday;
      let _day = weekday[deliveryDate.getDay()];
      let month = new Array();
      month[0] = theme.strings.date_formats.january;
      month[1] = theme.strings.date_formats.february;
      month[2] = theme.strings.date_formats.march;
      month[3] = theme.strings.date_formats.april;
      month[4] = theme.strings.date_formats.may;
      month[5] = theme.strings.date_formats.june;
      month[6] = theme.strings.date_formats.july;
      month[7] = theme.strings.date_formats.august;
      month[8] = theme.strings.date_formats.september;
      month[9] = theme.strings.date_formats.october;
      month[10] = theme.strings.date_formats.november;
      month[11] = theme.strings.date_formats.december;
      let _month = month[deliveryDate.getMonth()];
      document.querySelector(".dt-time").innerHTML = _day + ",&nbsp;" + deliveryDate.getDate() + "&nbsp;" + _month;
    },
    initSliderMedia: function() {
      let { mediaMain, mediaThumnails } = this.elms;
      this.mainSlider = mediaMain.init({ gutter: 12 });
      mediaThumnails.init();
    },
    handleVariantChange: function(variant) {
      let { skuElement, selectMaster, mediaMain } = this.elms;
      if (!variant) {
        this.updateVariantStatus();
        mediaMain.addClass("product-sold-out");
        return;
      }
      this.currentVariant = variant;
      this.updateLabelSave(variant);
      this.updateVariantStatus(variant);
      this.updatePrice(variant);
      this.updateURLHash(variant);
      this.updateProductId(variant);
      // FixOEM: este método viejo (updateAvailability) pedía la sección
      // completa de disponibilidad a Shopify y reemplazaba el contenedor
      // con el diseño ANTIGUO sin estilo ("Disponibilidad en Tiempo Real
      // x Sucursal", tarjetas planas) -- competía en una carrera contra
      // loadAvailability() (más abajo, línea ~429) que es el sistema
      // nuevo y correcto. Cuando la respuesta vieja llegaba después,
      // pisaba el diseño bueno con el feo. Se desactiva por completo:
      // loadAvailability(variant.id) ya se encarga de todo.
      // this.updateAvailability(variant);
      variant.available ? mediaMain.removeClass("product-sold-out") : mediaMain.addClass("product-sold-out");
      if (skuElement) {
        !!variant.sku ? (skuElement.innerHTML = variant.sku) && skuElement.closest(".product-details_sku").removeClass("d-none") : skuElement.closest(".product-details_sku").addClass("d-none");
      }
      if (!!variant.featured_media) {
        this.mainSlider.goTo(variant.featured_media.position - 1);
      }
      selectMaster.value = variant.id;

      // FixOEM: sincroniza DelightChat Back in Stock con la variante real.
      // El widget se inicializa con DCStoreConfig.availableVariant y puede
      // conservar el estado de la variante anterior si el selector cambia.
      document.documentElement.setAttribute(
        "data-fixoem-variant-available",
        variant.available ? "true" : "false"
      );

      if (window.DCStoreConfig) {
        window.DCStoreConfig.availableVariant = variant;
      }

      if (!document.getElementById("fixoem-delightchat-variant-sync")) {
        const delightChatSyncStyle = document.createElement("style");
        delightChatSyncStyle.id = "fixoem-delightchat-variant-sync";
        delightChatSyncStyle.textContent =
          'html[data-fixoem-variant-available="true"] #delightchat-back-in-stock-widget .css-1f6hfis{display:none!important}';
        document.head.appendChild(delightChatSyncStyle);
      }

      selectMaster.dispatchEvent(new Event("change", { bubbles: true }));
      document.dispatchEvent(
        new CustomEvent("variant:change", { detail: { variant } })
      );

      loadAvailability(variant.id);
    },
    initInventory() {
      let { inventoryElement } = this.elms;
      this.inventory = {
        setStatus: (status, variant) => {
          if (!this.settings.showInventory) {
            return;
          }
          inventoryElement.setAttribute("data-status", status);
          switch (status) {
            case "low-stock": {
              inventoryElement.querySelector(".inventory_low-stock").innerHTML = (variant.inventory_quantity > 1 ? theme.strings.product.itemsLowStock : theme.strings.product.itemLowStock).replace("{{quantity}}", variant.inventory_quantity);
              break;
            }
            case "items-stock": {
              inventoryElement.querySelector(".inventory_items-stock").innerHTML = (variant.inventory_quantity > 1 ? theme.strings.product.itemsStock : theme.strings.product.itemStock).replace("{{quantity}}", variant.inventory_quantity);
              break;
            }
          }
        }
      };
    },
    updateVariantStatus(variant) {
      let { addToCartButton } = this.elms;
      if (variant) {
        if (this.settings.enableSubscribe) {
          this.updateDynamicCheckout(variant.available);
          this.updateSubscribeForm(variant);
        }
        this.updateAddToCartButton(variant);
        this.updateInventory(variant);
      } else {
        addToCartButton.disabled = true;
        addToCartButton.querySelector("span").innerHTML = theme.strings.product.unavailable;
        document.querySelector(".product-wishlist-compare").addClass("d-none");
        document.querySelector(".people-in-cart").addClass("d-none");
        document.querySelector(".shipping-time").addClass("d-none");
        this.inventory.setStatus("out-stock");
      }
    },
    updateDynamicCheckout(variantAvailable) {
      let { dynamicCheckoutContainer } = this.elms;
      if (dynamicCheckoutContainer) {
        variantAvailable ? dynamicCheckoutContainer.removeClass("d-none") : dynamicCheckoutContainer.addClass("d-none");
      }
    },
    updateSubscribeForm(variant) {
      let { subscribeForm } = this.elms;
      let inputBody = subscribeForm.querySelector("input[name='contact[body]']");
      let subscribeFormWrapper = subscribeForm.querySelector(".js-product-subscribe");
      !AT.getParameterByName("contact_posted") && subscribeFormWrapper.removeClass("posted-successfully");
      inputBody.value = inputBody.dataset.value.replace("{{product_name}}", variant.name);
      variant.available ? subscribeFormWrapper.addClass("d-none") : subscribeFormWrapper.removeClass("d-none");
      subscribeForm.addEvent("submit", () => {
        AT.cookie.set("subscribe-variant-id", this.currentVariant.id);
      });
    },
    updateAddToCartButton(variant) {
      let { addToCartButton, quantityInputContainer } = this.elms;
      if (variant.available) {
        addToCartButton.disabled = false;
        addToCartButton.querySelector("span").innerHTML = variant.inventory_quantity == 0 && variant.inventory_policy == "continue" ? theme.strings.product.preorder : theme.strings.product.addToCart;
        this.settings.enableSubscribe && quantityInputContainer.removeClass("d-none");
        if (document.querySelector(".product-wishlist-compare")) {
          document.querySelector(".product-wishlist-compare").removeClass("d-none");
        }
        if (document.querySelector(".people-in-cart")) {
          document.querySelector(".people-in-cart").removeClass("d-none");
        }
        if (document.querySelector(".shipping-time")) {
          document.querySelector(".shipping-time").removeClass("d-none");
        }
        if (document.querySelector(".product-countdown-detail")) {
          document.querySelector(".product-countdown-detail").removeClass("d-none");
        }
      } else {
        addToCartButton.disabled = true;
        addToCartButton.querySelector("span").innerHTML = theme.strings.product.soldOut;
        this.settings.enableSubscribe && quantityInputContainer.addClass("d-none");
        if (document.querySelector(".product-wishlist-compare")) {
          document.querySelector(".product-wishlist-compare").addClass("d-none");
        }
        if (document.querySelector(".people-in-cart")) {
          document.querySelector(".people-in-cart").addClass("d-none");
        }
        if (document.querySelector(".shipping-time")) {
          document.querySelector(".shipping-time").addClass("d-none");
        }
        if (document.querySelector(".product-countdown-detail")) {
          document.querySelector(".product-countdown-detail").addClass("d-none");
        }
      }
    },
    updateInventory(variant) {
      const stockText = document.getElementById("inventory-quantity-available");

      // FixOEM: "Envío desde $60" es un texto fijo (solo escritorio,
      // ver CSS .fixoem-shipping-from-note), ya no depende de la
      // cantidad de piezas disponibles de la variante seleccionada.
      if (stockText) {
        stockText.textContent = `Envío desde $60`;
      }

      if (variant.available) {
        if (variant.inventory_management) {
          if (variant.inventory_policy == "continue" && variant.inventory_quantity < 1) {
            this.inventory.setStatus("pre-order", variant);
          } else {
            variant.inventory_quantity <= this.settings.inventoryThreshold ? this.inventory.setStatus("low-stock", variant) : this.inventory.setStatus("items-stock", variant);
          }
        } else {
          this.inventory.setStatus("in-stock");
        }
      } else {
        this.inventory.setStatus("out-stock");
      }
    },
    initFormAddToCart() {
      let { formElement, addToCartButton } = this.elms;
      formElement.addEvent("submit", (e) => {
        e.preventDefault();
        if (!addToCartButton.hasClass("has-pending")) {
          addToCartButton.insertAdjacentHTML("beforeend", '<svg class="svg-loading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; shape-rendering: auto;" width="28px" height="28px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" fill="none" stroke="var(--main-color)" stroke-width="5" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">  <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform></circle></svg>');
        }
        addToCartButton.addClass("pending", "has-pending");
        Cart.add(formElement).catch((error) => {
          AT.loadPopupMessage().then(() => {
            Popups.closeAll();
            PopupMessage.open(error.description);
          });
        }).finally(() => {
          addToCartButton.removeClass("pending");
        });
      });
    },
    initScrollToReviews() {
      let reviewsWidget = document.querySelector("#product-reviews-widget");
      let reviewsBadge = document.querySelector("#product-review-badge");
      if (reviewsBadge) {
        reviewsBadge.addEvent("click", () => AT.scrollTo(reviewsWidget, 1e3, reviewsWidget.click()));
      }
    },
    updateLabelSave(variant) {
      let { labelSaveContainer } = this.elms;
      let percentElement = labelSaveContainer.querySelector(".js-percent");
      let moneySaved = labelSaveContainer.querySelector(".js-money-saved");
      let { compare_at_price, price } = variant;
      if (compare_at_price > price) {
        moneySaved.innerHTML = (compare_at_price - price).toCurrency();
        percentElement.innerHTML = Math.round((compare_at_price - price) / compare_at_price * 100);
        labelSaveContainer.removeClass("d-none");
      } else {
        labelSaveContainer.addClass("d-none");
      }
    },
    updatePrice(variant) {
      let { priceCompareElement, priceElement } = this.elms;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceCompareElement.innerHTML = variant.compare_at_price.toCurrency();
        priceCompareElement.removeClass("d-none");
      } else {
        priceCompareElement.addClass("d-none");
      }
      priceElement.innerHTML = variant.price.toCurrency();
    },
    updateProductId(variant){
      const input = document.querySelector('input[type="hidden"][name="product-id"]');
      input.value = `${variant.id}`; // Cambia el valor al que tú quieras
    },
    updateAvailability(variant) {

      fetch(window.Shopify.routes.root + `variants/${variant.id}?section_id=pickup-availability`)
        .then(response => response.text())
        .then(text => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');

          // Obtener el contenido del template
          const pickupAvailabilityContent = doc.querySelector('.shopify-section');

          if (!pickupAvailabilityContent) {
            console.error('No se encontró el contenido de disponibilidad');
            return;
          }

          // Seleccionar contenedores específicos
          const desktopContainer = document.querySelector('[data-store-availability-container]');
          const mobileContainer = document.querySelector('[data-store-availability-container-two]');

          // Función para clonar y actualizar contenido
          const updateContainer = (container, content) => {
            if (!container) return;

            // Clonar el nodo para evitar conflictos de referencia DOM
            const clonedContent = content.cloneNode(true);

            // Limpiar y actualizar el contenedor
            container.innerHTML = '';
            container.appendChild(clonedContent);

            // Añadir clase específica según el contenedor
            container.classList.add(container === mobileContainer ? 'mobile-availability' : 'desktop-availability');
          };

          // Actualizar ambos contenedores con clones independientes
          updateContainer(desktopContainer, pickupAvailabilityContent);
          updateContainer(mobileContainer, pickupAvailabilityContent);

          // Opcional: Forzar reflow para animaciones
          if (desktopContainer) void desktopContainer.offsetWidth;
          if (mobileContainer) void mobileContainer.offsetWidth;

        })
        .catch(e => {
          console.error('Error al cargar disponibilidad:', e);
          // Mostrar error en ambos contenedores
          [desktopContainer, mobileContainer].forEach(container => {
            if (container) container.innerHTML = '<p>Error cargando disponibilidad</p>';
          });
        });
    },
    updateURLHash(variant) {
      let searchParams = window.location.search.replace("?", "").split("&").filter(Boolean);
      window.history.replaceState({}, "", AT.getParameterByName("variant") ? `${window.location.pathname}?${searchParams.map((param) => param.includes("variant") ? "variant=" + variant.id : param).join("&")}` : (searchParams.unshift("variant=" + variant.id), `${window.location.pathname}?${searchParams.join("&")}`));
    },
    switchVariantById(variantId) {
      let { swatchContainer } = this.elms;
      let variantFound = theme.product.variants.find((i) => i.id == variantId);
      if (!variantFound) {
        return;
      }
      variantFound.options.forEach((option, index) => {
        [...swatchContainer.querySelectorAll(`[name='option${index + 1}']`)].find((element) => {
          switch (element.tagName) {
            case "INPUT":
              element.value == option && (element.checked = true, element.dispatchEvent(new Event("change")));
              break;
            case "SELECT":
              element.value = option;
              element.dispatchEvent(new Event("change"));
              break;
          }
        });
      });
    }
  };

  let availabilityLoaded = false
  let currentVariantId = null

  function toggleAvailability(variantId) {
    const modal = document.getElementById('PickupAvailabilityModal');
    const button = document.getElementById('toggleAvailabilityBtn');
    const chevron = document.getElementById('chev');

    if (!modal || !button) return;

    let isOpen = modal.style.display !== 'none';

    const guarantee = document.getElementById('show-on-open');
    const guarantee_two = document.getElementById('show-on-open-two');

    // if (!isOpen) {
    //   // Abrir modal
    //   modal.style.display = 'block';
    //   button.setAttribute('aria-expanded', 'true');
    //   if (chevron) {
    //     chevron.style.transform = 'rotate(180deg)';
    //   }

      // Cargar disponibilidad si no se ha cargado o si cambió la variante
      if (!availabilityLoaded || currentVariantId !== variantId) {
        currentVariantId = variantId;
        availabilityLoaded = true;
        if (variantId) {
          loadAvailability(variantId);
        } else {
          const availabilityContent = document.getElementById('availabilityContent');
          if (availabilityContent) {
            availabilityContent.innerHTML = `
              <div class="availability-error">
                No se pudo determinar la variante del producto.
              </div>
            `;
          }
        }
      }

    //   if (guarantee) guarantee.style.display = 'block';
    //   if (guarantee_two) guarantee_two.style.display = 'none';

    // } else {
    //   // Cerrar modal
    //   modal.style.display = 'none';
    //   button.setAttribute('aria-expanded', 'false');
    //   if (chevron) {
    //     chevron.style.transform = 'rotate(0deg)';
    //   }

    //   if (guarantee) guarantee.style.display = 'none';
    //   if (guarantee_two) guarantee_two.style.display = 'block';
    // }
  }

  let availabilityRequestId = 0;

  async function loadAvailability(variantId) {
    const requestId = ++availabilityRequestId;
    const availabilityContent = document.getElementById('availabilityContent');

    if (!availabilityContent) return;

    // Mostrar loading
    availabilityContent.innerHTML = `
      <div style="grid-column: 1 / -1; text-align: center; padding: 20px;">
        <div class="loading-spinner" style="display: inline-block; width: 20px; height: 20px; border: 2px solid #f3f3f3; border-top: 2px solid #233F8E; border-radius: 50%; animation: spin 1s linear infinite;"></div>
        <span style="margin-left: 10px;">Cargando disponibilidad...</span>
      </div>
    `;

    try {
      console.log('[loadAvailability] Fetching for variant ID:', variantId);
      const response = await fetch(`https://vudtt0b1yk.execute-api.us-east-2.amazonaws.com/PRODUCTION/inventory?action=inventory&variantId=${variantId}`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (requestId !== availabilityRequestId) return;
      console.log('[loadAvailability] API response:', data);

      if (data.error) {
        throw new Error(data.error);
      }

      // Procesar los datos de inventario
      const inventoryData = data.data?.productVariant?.inventoryItem;
      if (!inventoryData || !inventoryData.inventoryLevels?.nodes) {
        throw new Error('No inventory data found');
      }

      renderAvailability(inventoryData.inventoryLevels.nodes);

    } catch (error) {
      if (requestId !== availabilityRequestId) return;
      console.error('[loadAvailability] Error:', error);
      availabilityContent.innerHTML = `
        <div class="availability-error">
          Error al cargar disponibilidad: ${error.message}
          <br><small>Por favor, inténtalo de nuevo más tarde.</small>
        </div>
      `;
    }
  }

  // FixOEM: rediseño del widget de disponibilidad por sucursal.
  // Antes: grid 2 columnas de tarjetas idénticas con ✅/❌ emoji.
  // Ahora: sucursal en línea + sucursal física destacada arriba (con
  // botón de acción), el resto como lista compacta con foco de color
  // por estado (disponible / últimas piezas / agotado), y un enlace al
  // final. Usa los mismos datos reales (nombre de sucursal, cantidad
  // disponible) que ya entrega la API -- no se inventa nada.
  const AVAILABILITY_LOW_STOCK_THRESHOLD = 3;

  function getAvailabilityStatus(qty) {
    if (qty <= 0) return 'agotado';
    if (qty <= AVAILABILITY_LOW_STOCK_THRESHOLD) return 'ultimas';
    return 'disponible';
  }

  // FixOEM: "últimas piezas" ya NO se marca en amarillo -- se ve igual
  // que "disponible" (verde). Solo "agotado" mantiene su propio color.
  // El texto ("Últimas X piezas") se conserva para dar el aviso, solo
  // cambia el color.
  const AVAILABILITY_STATUS_COLOR = {
    disponible: '#28a745',
    ultimas: '#28a745',
    agotado: '#dc3545'
  };

  function availabilityDot(status) {
    return `<span style="width:10px;height:10px;border-radius:50%;background:${AVAILABILITY_STATUS_COLOR[status]};display:inline-block;flex:0 0 auto;"></span>`;
  }

  function availabilityStockText(entry) {
    if (entry.status === 'agotado') {
      return `<span style="color:${AVAILABILITY_STATUS_COLOR.agotado};font-weight:700;">Agotado</span>`;
    }
    const label = entry.available === 1 ? 'pieza disponible' : 'piezas disponibles';
    const text = entry.status === 'ultimas' ? `Últimas ${entry.available} piezas` : `${entry.available} ${label}`;
    return `<span style="color:${AVAILABILITY_STATUS_COLOR[entry.status]};font-weight:700;">${text}</span>`;
  }

  function availabilityStoreIcon() {
    return `
      <div style="width:34px;height:34px;border-radius:9px;background:#eef1f7;display:flex;align-items:center;justify-content:center;flex:0 0 auto;">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2E4695" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 9l1.2-5.2A1 1 0 0 1 5.17 3h13.66a1 1 0 0 1 .97.78L21 9"/>
          <path d="M4 9a2.2 2.2 0 0 0 4.2 1 2.2 2.2 0 0 0 4.2 0 2.2 2.2 0 0 0 4.2 0 2.2 2.2 0 0 0 4.2-1"/>
          <path d="M5 9.5V20a1 1 0 0 0 1 1h4v-5.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1V21h4a1 1 0 0 0 1-1V9.5"/>
        </svg>
      </div>
    `;
  }

  function scrollToAddToCart() {
    const atc = document.querySelector('.js-atc-btn, [name="add"]');
    if (!atc) return;
    atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
    atc.style.transition = 'box-shadow .2s ease';
    atc.style.boxShadow = '0 0 0 4px rgba(27,42,74,0.35)';
    setTimeout(() => { atc.style.boxShadow = ''; }, 1200);
  }

  // FixOEM: los botones "Comprar ahora" / "Recoger en tienda" del
  // widget de disponibilidad antes solo hacían scroll -- ahora
  // realmente agregan el producto al carrito, haciendo click sobre
  // el botón real de "Agregar al carrito" del tema (así se respeta
  // toda la lógica existente: variante seleccionada, cantidad,
  // apertura del carrito, validaciones, etc.). Se hace scroll primero
  // para que el usuario vea el feedback visual del tema al agregarse.
  function buyNowFromAvailability() {
    const atc = document.querySelector('.js-atc-btn, [name="add"]');
    if (!atc || atc.disabled) return;
    atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
    atc.style.transition = 'box-shadow .2s ease';
    atc.style.boxShadow = '0 0 0 4px rgba(27,42,74,0.35)';
    setTimeout(() => { atc.style.boxShadow = ''; }, 1200);
    setTimeout(() => { atc.click(); }, 450);
  }

  // FixOEM: en pantallas angostas, la tarjeta "Venta en Línea / CEDIS"
  // no tiene espacio para el nombre + existencias + botón en una sola
  // línea -- el botón "Comprar ahora" se encogía (flex-shrink) hasta
  // verse chico y feo. En vez de eso, en móvil el botón pasa a su
  // propia línea y ocupa el ancho completo de la tarjeta.
  function ensureAvailabilityMobileStyles() {
    if (document.getElementById('fixoem-availability-mobile-fix')) return;
    const style = document.createElement('style');
    style.id = 'fixoem-availability-mobile-fix';
    style.textContent = `
      @media (max-width: 480px) {
        .availability-cta-buy {
          flex: 1 1 100% !important;
          width: 100% !important;
          margin-top: 4px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function renderAvailability(inventoryLevels) {
    const availabilityContent = document.getElementById('availabilityContent');
    if (!availabilityContent) return;
    ensureAvailabilityMobileStyles();

    const storeLocations = inventoryLevels;

    if (storeLocations.length === 0) {
      availabilityContent.innerHTML = `
        <div style="text-align: center; padding: 20px;">
          No hay información de disponibilidad en sucursales.
        </div>
      `;
      return;
    }

    const entries = storeLocations.map(level => {
      const location = level.location;
      const availableQuantity = level.quantities.find(q => q.name === 'available');
      const available = availableQuantity ? availableQuantity.quantity : 0;
      return {
        name: location.name,
        available: available,
        status: getAvailabilityStatus(available),
        isOnline: /l[ií]nea|cedis|online/i.test(location.name)
      };
    });

    const onlineEntry = entries.find(e => e.isOnline) || null;
    // FixOEM: se quitó la tarjeta destacada de "Recoger en tienda" (Puebla)
    // -- esa sucursal ahora se muestra igual que las demás, dentro del
    // grid de 2 columnas.
    const restEntries = entries.filter(e => e !== onlineEntry);

    let html = '';

    if (onlineEntry) {
      html += `
        <div class="point_available point_available--featured" style="display:flex; flex-wrap:wrap; align-items:center; gap:8px 10px; background:#fff; border:1px solid rgba(27,42,74,0.12); border-radius:12px; padding:10px 12px; max-width:100%; box-sizing:border-box;">
          ${availabilityDot(onlineEntry.status)}
          ${availabilityStoreIcon()}
          <div style="flex:1 1 140px; min-width:0;">
            <div style="font-weight:800; color:#2E4695; font-size:13px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">${onlineEntry.name}</div>
            <div style="font-size:12px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">${availabilityStockText(onlineEntry)}</div>
          </div>
          <button type="button" class="availability-cta-buy" style="background:#2E4695; color:#fff; border:1.5px solid #2E4695; border-radius:8px; padding:7px 13px; font-weight:700; font-size:12px; white-space:nowrap; cursor:pointer; flex:0 1 150px; min-width:0; max-width:100%; text-align:center; box-sizing:border-box;">Comprar ahora</button>
        </div>
      `;
    }

    if (restEntries.length) {
      // FixOEM: lista de sucursales en grid de 2 columnas (antes era
      // una sola columna apilada) -- cada sucursal es su propia
      // tarjeta con borde, ya que en 2 columnas un borde compartido
      // tipo "lista" no se ve bien.
      html += `<div class="point_available-list" style="display:grid; grid-template-columns:1fr 1fr; gap:8px;">`;
      restEntries.forEach((entry) => {
        html += `
          <div class="point_available point_available--row" style="display:flex; align-items:center; gap:8px; padding:10px 12px; background:#fff; border:1px solid rgba(27,42,74,0.1); border-radius:10px; min-width:0; max-width:100%; box-sizing:border-box;">
            ${availabilityDot(entry.status)}
            <div style="min-width:0; flex:1 1 auto; overflow:hidden;">
              <div class="info_availability" style="font-size:12px; font-weight:700; color:#2E4695; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">${entry.name}</div>
              <div style="font-size:11px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">${availabilityStockText(entry)}</div>
            </div>
          </div>
        `;
      });
      html += `</div>`;
    }

    availabilityContent.innerHTML = html;

    const buyBtn = availabilityContent.querySelector('.availability-cta-buy');
    if (buyBtn) buyBtn.addEventListener('click', buyNowFromAvailability);
  }

  // document.addEventListener('click', function(e) {
  //   if (e.target && e.target.id === 'toggleAvailabilityBtn') {
  //     e.preventDefault();
  //     // Obtener el variant ID desde el botón o desde el contexto
  //     const variantId = e.target.dataset.variantId || window.currentProductVariantId;
  //     toggleAvailability(variantId);
  //   }
  // });

  // ══════════════════════════════════════════════════════════════
  // FixOEM: rediseño de la tabla "Precio de Mayoreo" (app Samita
  // Wholesale Pricing, tabla <table class="volumeDisplayTableForm-
  // options">). No podemos editar el HTML que genera la app
  // directamente, así que se lee la tabla real (rango de piezas +
  // precio, datos reales de la app) y se oculta, reemplazándola por
  // una tarjeta con barra de progreso ("Te faltan X piezas...") que
  // se actualiza en vivo según la cantidad seleccionada, más las
  // filas numeradas con línea punteada y el último nivel destacado
  // como "MEJOR PRECIO". Un MutationObserver espera a que la app
  // termine de renderizar la tabla (carga asíncrona).
  // ══════════════════════════════════════════════════════════════
  function fixoemInitWholesalePricingWidget() {
    const productRoot = document.querySelector('.section-product-template');
    if (!productRoot) return;
    const table = productRoot.querySelector('.samitaWS_volumeTable_product_form table.volumeDisplayTableForm-options:not([data-fixoem-enhanced]), .product-table-volume table.volumeDisplayTableForm-options:not([data-fixoem-enhanced])');
    if (!table) return;

    const rows = [...table.querySelectorAll('tbody tr')];
    const tiers = rows.map((tr) => {
      const cells = [...tr.children].map((td) => td.textContent.trim());
      const rangeText = cells[0];
      const priceText = cells[1];
      const minMatch = rangeText ? rangeText.match(/(\d+)/) : null;
      const minQty = minMatch ? parseInt(minMatch[1], 10) : null;
      return { rangeText, priceText, minQty };
    }).filter((t) => t.minQty !== null && t.priceText);

    if (!tiers.length) return;
    table.dataset.fixoemEnhanced = '1';
    productRoot.querySelectorAll('.fixoem-wholesale-widget').forEach(function (card) { card.remove(); });

    const qtyInput = document.querySelector('input[name="quantity"]');
    const circumference = 119.4; // 2 * PI * r(19), matches the SVG ring below

    const wrapper = document.createElement('div');
    wrapper.className = 'fixoem-wholesale-widget';
    wrapper.innerHTML = `
      <div class="fixoem-wholesale-widget_header">
        <div class="fixoem-wholesale-widget_icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2E4695" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20.59 13.41L11 3.83A2 2 0 0 0 9.59 3H4a1 1 0 0 0-1 1v5.59a2 2 0 0 0 .59 1.41l9.58 9.58a2 2 0 0 0 2.83 0l4.59-4.59a2 2 0 0 0 0-2.83z"/>
            <circle cx="7.5" cy="7.5" r="1.5" fill="#2E4695" stroke="none"/>
          </svg>
        </div>
        <div>
          <div class="fixoem-wholesale-widget_title">Precio de Mayoreo</div>
          <div class="fixoem-wholesale-widget_subtitle">Puedes combinar dif modelos, misma categoría</div>
        </div>
      </div>
      <div class="fixoem-wholesale-widget_progress">
        <div class="fixoem-wholesale-widget_ring-wrap">
          <svg width="46" height="46" viewBox="0 0 46 46">
            <circle cx="23" cy="23" r="19" fill="none" stroke="#eee" stroke-width="4"/>
            <circle class="fixoem-wholesale-widget_ring" cx="23" cy="23" r="19" fill="none" stroke="#FED700" stroke-width="4" stroke-linecap="round" stroke-dasharray="${circumference}" stroke-dashoffset="${circumference}" transform="rotate(-90 23 23)"/>
          </svg>
          <div class="fixoem-wholesale-widget_ring-qty"><span class="fixoem-wholesale-widget_qty">1</span></div>
        </div>
        <div class="fixoem-wholesale-widget_progress-text">
          <div class="fixoem-wholesale-widget_progress-title"></div>
          <div class="fixoem-wholesale-widget_progress-bar"><div class="fixoem-wholesale-widget_progress-fill"></div></div>
          <div class="fixoem-wholesale-widget_progress-sub"><span class="fixoem-wholesale-widget_current">1</span> de <span class="fixoem-wholesale-widget_target">${tiers[0].minQty}</span> piezas</div>
        </div>
      </div>
      <div class="fixoem-wholesale-widget_tiers">
        ${tiers.map((t, i) => `
          <div class="fixoem-wholesale-widget_tier${i === tiers.length - 1 ? ' fixoem-wholesale-widget_tier--best' : ''}" data-tier-index="${i}" data-tier-min="${t.minQty}">
            <span class="fixoem-wholesale-widget_tier-num">${i + 1}</span>
            <span class="fixoem-wholesale-widget_tier-range">${t.rangeText}<br><small>piezas</small></span>
            <span class="fixoem-wholesale-widget_tier-dots"></span>
            <span class="fixoem-wholesale-widget_tier-price">${t.priceText} c/u</span>
            ${i === tiers.length - 1 ? '<span class="fixoem-wholesale-widget_tier-badge">★ MEJOR PRECIO</span>' : ''}
          </div>
        `).join('')}
      </div>
      <div class="fixoem-wholesale-widget_footer">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2E4695" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 17l6-6 4 4 8-8"/><path d="M15 7h6v6"/></svg>
        A mayor volumen, menor precio
      </div>
    `;

    const container = table.closest('.samitaWS-volumeTable-widget-wrapper') || table.parentElement;
    container.style.display = 'none';
    container.insertAdjacentElement('afterend', wrapper);

    // FixOEM: la app también dibuja un título "Precio de Mayoreo" en
    // negro plano ARRIBA de la tabla (fuera de este contenedor, es el
    // hermano anterior de .product-table-volume) -- se oculta también
    // para no repetirlo, ya que nuestra tarjeta ya trae su propio
    // encabezado con el mismo texto.
    const outerBlock = container.closest('.product-table-volume') || container.parentElement;
    const legacyHeading = outerBlock ? outerBlock.previousElementSibling : null;
    if (legacyHeading && /^(?:precio|precios) de mayoreo$/i.test((legacyHeading.textContent || '').trim()) && !legacyHeading.querySelector('input, button, form, .product-table-volume')) {
      legacyHeading.style.display = 'none';
    }

    function updateWholesaleProgress() {
      const qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      const nextTier = tiers.find((t) => qty < t.minQty);
      wrapper.querySelector('.fixoem-wholesale-widget_qty').textContent = qty;
      wrapper.querySelector('.fixoem-wholesale-widget_current').textContent = qty;
      const titleEl = wrapper.querySelector('.fixoem-wholesale-widget_progress-title');
      const fillEl = wrapper.querySelector('.fixoem-wholesale-widget_progress-fill');
      const targetEl = wrapper.querySelector('.fixoem-wholesale-widget_target');
      const ring = wrapper.querySelector('.fixoem-wholesale-widget_ring');

      if (nextTier) {
        const remaining = nextTier.minQty - qty;
        const pct = Math.min(100, Math.max(4, Math.round((qty / nextTier.minQty) * 100)));
        fillEl.style.width = pct + '%';
        targetEl.textContent = nextTier.minQty;
        titleEl.innerHTML = `Estas a <strong>${remaining}</strong> pieza${remaining === 1 ? '' : 's'} para activar precio de mayoreo`;
        ring.setAttribute('stroke-dashoffset', String(circumference * (1 - pct / 100)));
      } else {
        fillEl.style.width = '100%';
        targetEl.textContent = qty;
        titleEl.textContent = '¡Ya tienes el mejor precio de mayoreo!';
        ring.setAttribute('stroke-dashoffset', '0');
      }

      // FixOEM: marcar en amarillo el escalón que la cantidad actual ya
      // alcanzó (no necesariamente el último/mejor precio) -- se calcula
      // el de mayor minQty tal que qty >= minQty; si la cantidad todavía
      // no llega al primer escalón, ninguno se marca como "alcanzado".
      let reachedIndex = -1;
      tiers.forEach((t, i) => {
        if (qty >= t.minQty) reachedIndex = i;
      });
      wrapper.querySelectorAll('.fixoem-wholesale-widget_tier').forEach((row) => {
        const idx = parseInt(row.getAttribute('data-tier-index'), 10);
        row.classList.toggle('fixoem-wholesale-widget_tier--reached', idx === reachedIndex);
      });

      // FixOEM: dispara un evento propio cada vez que se recalcula, para
      // que quien necesite enterarse (p. ej. la barra fija de móvil)
      // pueda reaccionar sin tener que adivinar qué elemento de precio
      // es el correcto -- eso lo resuelve fixoemGetEffectivePriceText()
      // más abajo, que ya sabe leer el precio real que pone Samita.
      document.dispatchEvent(new CustomEvent('fixoem:qty-updated', { detail: { qty, reachedIndex } }));
    }

    updateWholesaleProgress();

    // FixOEM: los botones +/- del selector de cantidad actualizan
    // qtyInput.value directamente por JS SIN disparar 'input'/'change'
    // en todos los casos. Eso no solo afectaba a este widget (ya se
    // resolvía con un poll), sino también a Samita: su propio precio
    // con descuento (".samitaWS-customized-price") solo se recalcula
    // cuando el campo de cantidad dispara un 'change' real -- si el
    // usuario usa +/- y ese evento nunca llega, Samita se queda
    // mostrando el precio base para siempre, aunque la cantidad ya
    // haya subido. Por eso, además de refrescar este widget, el poll
    // ahora también dispara un 'change' real cada vez que detecta que
    // el valor cambió, para que Samita (y cualquier otro script que
    // dependa de ese evento) se entere también.
    let fixoemLastPolledQty = qtyInput ? qtyInput.value : null;
    function fixoemPollQuantity() {
      updateWholesaleProgress();
      if (qtyInput && qtyInput.value !== fixoemLastPolledQty) {
        fixoemLastPolledQty = qtyInput.value;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (qtyInput) {
      qtyInput.addEventListener('input', updateWholesaleProgress);
      qtyInput.addEventListener('change', updateWholesaleProgress);
      qtyInput.parentElement?.addEventListener('click', () => setTimeout(fixoemPollQuantity, 0));
    }
  }

  // FixOEM: da el precio efectivo que se debe mostrar en cualquier
  // lugar que necesite "el precio actual" (por ejemplo, la barra fija
  // de móvil). Samita, cuando la cantidad alcanza un escalón de
  // mayoreo, agrega DOS elementos nuevos dentro del precio de arriba:
  // ".samitaWS-customized-original-price" (el precio tachado, sin
  // descuento) y ".samitaWS-customized-price" (el precio real con
  // descuento) -- si existen y están visibles, ese segundo es el que
  // hay que mostrar. Si todavía no existen (cantidad por debajo del
  // primer escalón), se usa el precio normal de siempre.
  function fixoemGetEffectivePriceText() {
    const cust = document.querySelector('.samitaWS-customized-price .money');
    if (cust && cust.offsetParent !== null) {
      return cust.textContent.trim();
    }
    const plain = document.querySelector('.product-details_price .js-price .money');
    return plain ? plain.textContent.trim() : null;
  }
  window.fixoemGetEffectivePriceText = fixoemGetEffectivePriceText;

  // ══════════════════════════════════════════════════════════════
  // FixOEM: "Agregar al Carrito" y "Compra ahora" en la misma línea.
  // En el DOM real, el botón "Agregar al Carrito" vive DENTRO del
  // formulario (junto al selector de Cantidad), mientras que "Compra
  // ahora" es un bloque APARTE (".accelerated-container"), hermano del
  // formulario completo -- por eso quedaban uno debajo del otro, no
  // hay forma de ponerlos en fila solo con CSS sin moverlos en el DOM.
  // Se mueve "Compra ahora" para que quede como hermano real de
  // "Agregar al Carrito" (junto, no dentro de Cantidad), envueltos en
  // una fila flex -- Cantidad se queda arriba, sin tocarla.
  // ══════════════════════════════════════════════════════════════
  // FixOEM: se vio un bug donde, tras un re-render del formulario
  // (cambio de cantidad/variante que Shopify vuelve a pintar desde el
  // servidor), la función corría una sola vez con timeouts fijos y
  // dejaba una .fixoem-btn-row VIEJA huérfana con un botón "Agregar al
  // Carrito" fantasma, mientras se creaba un botón nuevo aparte --
  // resultado: 2 botones "Agregar al Carrito" apilados con "Compra
  // ahora" en medio. Ahora la función es "idempotente" (se puede
  // llamar cuantas veces sea, siempre deja UNA sola fila con el botón
  // y el accelerated-container ACTUALES) y se re-ejecuta también con
  // un MutationObserver que detecta cuando el formulario se vuelve a
  // pintar, no solo al cargar la página.
  function fixoemInitButtonRow() {
    const scope = document.getElementById('product-info_action_inner') || document;

    // FixOEM: el propio TEMA (product-template.liquid, ya desactivado
    // en el archivo fuente) creaba en móvil un botón "Agregar al
    // Carrito" clonado (.btn-atc-proxy) dentro de su propia
    // .mobile-buttons-row, adueñándose del accelerated-container y
    // rompiendo esta fila -- si por caché del navegador esa versión
    // vieja todavía llega a ejecutarse, se deshace aquí: se saca el
    // accelerated-container de vuelta y se borra el clon y su wrapper.
    scope.querySelectorAll('.mobile-buttons-row').forEach((oldWrapper) => {
      const accelInside = oldWrapper.querySelector('.accelerated-container');
      if (accelInside) oldWrapper.parentElement.insertBefore(accelInside, oldWrapper);
      oldWrapper.remove();
    });
    scope.querySelectorAll('.btn-atc-proxy').forEach((el) => el.remove());

    const atcBtns = Array.from(scope.querySelectorAll('.btn-add-to-cart.js-atc-btn'));
    const accelerated = Array.from(scope.querySelectorAll('.accelerated-container'));
    if (!atcBtns.length || !accelerated.length) return;

    // FixOEM: por seguridad, si por lo que sea (re-render de Shopify,
    // etc.) llega a haber MÁS de un botón "Agregar al Carrito" o más de
    // un "Compra ahora" sueltos en el formulario, se conserva solo el
    // ÚLTIMO de cada uno (el más reciente en el DOM) y se eliminan los
    // demás -- así nunca se ven duplicados apilados, sin importar de
    // dónde haya salido la copia extra.
    const atcBtn = atcBtns[atcBtns.length - 1];
    const accel = accelerated[accelerated.length - 1];
    atcBtns.slice(0, -1).forEach((el) => el.remove());
    accelerated.slice(0, -1).forEach((el) => el.remove());

    // Limpia cualquier fila vieja huérfana (de un render anterior) que
    // no sea la que ya envuelve al botón actual.
    scope.querySelectorAll('.fixoem-btn-row').forEach((oldRow) => {
      if (oldRow !== atcBtn.parentElement) oldRow.remove();
    });

    if (atcBtn.parentElement && atcBtn.parentElement.classList.contains('fixoem-btn-row')) {
      // Ya está armada -- solo asegura que el accelerated-container
      // actual (pudo haberse vuelto a renderizar) esté adentro.
      if (accel.parentElement !== atcBtn.parentElement) {
        atcBtn.parentElement.appendChild(accel);
      }
      return;
    }
    const row = document.createElement('div');
    row.className = 'fixoem-btn-row';
    atcBtn.parentElement.insertBefore(row, atcBtn);
    row.appendChild(atcBtn);
    row.appendChild(accel);
  }

  [800].forEach((delay) => setTimeout(fixoemInitButtonRow, delay));
  document.addEventListener('DOMContentLoaded', fixoemInitButtonRow);
  fixoemInitButtonRow();

  // FixOEM: además de los timeouts de arriba (para la carga inicial),
  // se observa el contenedor del formulario por si Shopify lo vuelve a
  // pintar más tarde (cambio de variante/cantidad) -- así la fila se
  // re-arma sola sin dejar botones duplicados, sin importar cuánto
  // tiempo después del load ocurra el cambio.
  const fixoemBtnRowScope = document.getElementById('product-info_action_inner');
  if (fixoemBtnRowScope && window.MutationObserver) {
    let fixoemBtnRowPending = false;
    const fixoemBtnRowObserver = new MutationObserver(() => {
      if (fixoemBtnRowPending) return;
      fixoemBtnRowPending = true;
      setTimeout(() => {
        fixoemBtnRowPending = false;
        fixoemInitButtonRow();
      }, 50);
    });
    fixoemBtnRowObserver.observe(fixoemBtnRowScope, { childList: true, subtree: true });
  }

  const fixoemWholesaleObserver = new MutationObserver(function () {
    fixoemInitWholesalePricingWidget();
  });
  const fixoemWholesaleScope = document.querySelector('.product-info_details') || document.body;
  fixoemWholesaleObserver.observe(fixoemWholesaleScope, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', fixoemInitWholesalePricingWidget);
  fixoemInitWholesalePricingWidget();

  // FixOEM: cuando un producto NO tiene reseñas ni preguntas, Judge.me
  // SÍ genera contenido dentro de su badge (texto literal "Sin reseñas"
  // / "Sin preguntas"), solo que el propio Judge.me le pone
  // "style=display:none" a ese div interno (".jdgm-prev-badge") para
  // ocultarlo -- por eso NO basta con revisar si el texto está vacío
  // (no lo está). El contenedor ".product-info_reviews" del theme, sin
  // embargo, no sabe nada de esto y siempre reserva un alto mínimo de
  // 28px + 12px de margen, dejando un hueco en blanco grande debajo del
  // título. Aquí se usa la misma señal que ya usa Judge.me (el
  // display:none que él mismo aplica) para colapsar también el
  // contenedor exterior del theme.
  function fixoemCollapseEmptyReviewBadges() {
    document.querySelectorAll('.product-info_reviews').forEach((wrap) => {
      const outer = wrap.querySelector('.jdgm-preview-badge, .jdgm-prev-badge');
      if (!outer) return;
      const inner = outer.querySelector('.jdgm-prev-badge') || outer;
      const isEmpty = getComputedStyle(inner).display === 'none';
      if (isEmpty) {
        wrap.style.minHeight = '0';
        wrap.style.margin = '0';
        wrap.style.display = 'none';
      } else {
        wrap.style.minHeight = '';
        wrap.style.margin = '';
        wrap.style.display = '';
      }
    });
  }

  // Judge.me carga su widget de forma asíncrona, así que se revisa
  // varias veces tras la carga inicial y también ante cualquier cambio
  // en el DOM (por ejemplo, al cambiar de variante).
  [800, 2500].forEach((delay) => {
    setTimeout(fixoemCollapseEmptyReviewBadges, delay);
  });
  const fixoemReviewBadgeObserver = new MutationObserver(function () {
    fixoemCollapseEmptyReviewBadges();
  });
  document.querySelectorAll('.product-info_reviews').forEach((scope) => {
    fixoemReviewBadgeObserver.observe(scope, { childList: true, subtree: true });
  });
  document.addEventListener('DOMContentLoaded', fixoemCollapseEmptyReviewBadges);

  // ══════════════════════════════════════════════════════════════
  // FixOEM: sección "Otras piezas para este modelo" -- se probó
  // primero construir un "frecuentemente comprados juntos" a partir de
  // pedidos reales, pero al revisar pedidos reales (vía Shopify) se vio
  // que casi todos los pedidos con varias piezas son técnicos comprando
  // piezas de MODELOS DISTINTOS en un solo pedido (para reparaciones
  // distintas) -- no hay señal real de "comprados juntos" por
  // compatibilidad. En cambio SÍ hay datos reales y consistentes por
  // modelo (ej. "Centro Carga Samsung A02S", "Flex Encendido Samsung
  // A02S", "Glass Samsung A02s" comparten el código de modelo "A02S").
  // Esta función extrae la marca + código(s) de modelo del título del
  // producto actual y usa el buscador nativo de Shopify (Predictive
  // Search API pública, /search/suggest.json -- mismos datos reales que
  // usa la barra de búsqueda del sitio) para traer otras piezas reales
  // de ese mismo modelo. Si el producto tiene un metafield
  // "custom.frequently_bought_with" con una relación de compra conjunta
  // real y fuerte (verificada aparte con datos de pedidos), esos
  // productos se muestran primero, antes de las piezas del mismo modelo.
  // ══════════════════════════════════════════════════════════════
  function fixoemExtractModelQuery(title) {
    if (!title) return '';
    const brandMatch = title.match(/\b(Samsung|iPhone|Apple|Xiaomi|Redmi|Poco|Motorola|Moto|Huawei|Honor|LG|Sony|Nokia|ZTE|Realme|Oppo|Vivo|Alcatel|Blu|Lenovo|Google|Pixel|Nintendo)\b/i);
    const brand = brandMatch ? brandMatch[0] : '';
    // Códigos de modelo: letras+números pegados (ej. A02S, A025F,
    // XT2239, K41S, S908, M2007J20CG) -- se ignoran palabras genéricas
    // comunes en los títulos (Display, Flex, Centro, Carga, Ips, Led, Sm).
    const stopWords = /^(display|flex|centro|carga|glass|charola|sim|lente|camara|bateria|ips|led|oled|tft|sm|touch|tapa|trasera|antena|home|jack|audio|encendido|core|plus|pro|max|lite|nfc|dual|negro|azul|rojo|dorado|plata|verde)$/i;
    const rawTokens = title.match(/\b[A-Za-z]{1,4}-?\d{1,5}[A-Za-z]{0,4}\b/g) || [];
    const codes = rawTokens.filter((t) => !stopWords.test(t));
    const parts = [brand, codes[0] || ''].filter(Boolean);
    return parts.join(' ').trim();
  }

  function fixoemRenderRelatedProducts(container, products, currentHandle) {
    const filtered = products.filter((p) => p.handle !== currentHandle && p.url);
    if (!filtered.length) {
      container.style.display = 'none';
      return;
    }
    const cardsHtml = filtered.slice(0, 8).map((p) => {
      const img = p.image ? `<img src="${p.image}" alt="${(p.title || '').replace(/"/g, '&quot;')}" loading="lazy">` : '';
      const price = p.price ? `<span class="fixoem-related-products_price">${p.price}</span>` : '';
      return `
        <a class="fixoem-related-products_card" href="${p.url}">
          <span class="fixoem-related-products_img">${img}</span>
          <span class="fixoem-related-products_title">${p.title || ''}</span>
          ${price}
        </a>
      `;
    }).join('');
    container.innerHTML = `
      <div class="fixoem-related-products_header">
        <span class="fixoem-related-products_title-main">Otras piezas para este modelo</span>
      </div>
      <div class="fixoem-related-products_row">${cardsHtml}</div>
    `;
    container.style.display = '';
    fixoemAlignRelatedProductsCard();
  }

  // FixOEM: "Otras piezas para este modelo" vive en la columna
  // izquierda (debajo de las miniaturas de la galería) y "Formas de
  // recibir tu pedido" vive en la columna derecha -- son dos columnas
  // independientes que no comparten una fila de grid, así que sus
  // alturas no se alinean solas (la izquierda suele quedar más arriba
  // porque las miniaturas ocupan menos que el widget de disponibilidad
  // por sucursal de la derecha). Se mide en tiempo real dónde empieza
  // "Formas de recibir tu pedido" y se empuja "Otras piezas" con
  // margin-top para que ambas arranquen exactamente a la misma altura.
  // Se recalcula si cambia el tamaño de pantalla o si el contenido de
  // la derecha cambia (ej. el widget de disponibilidad carga async).
  function fixoemAlignRelatedProductsCard() {
    const card = document.getElementById('fixoem-related-model-products');
    // FixOEM: hay 2 elementos ".shipping-time" en el DOM (versión
    // "shipping-v2" y "shipping"), y el que NO se usa no siempre trae
    // la clase "d-none" en sí mismo -- a veces queda oculto por un
    // ancestro. Por eso se busca por visibilidad real (offsetParent),
    // no solo por la clase.
    const target = Array.from(document.querySelectorAll('.shipping-time'))
      .find((el) => el.offsetParent !== null);
    if (!card || !target || card.style.display === 'none') return;
    // En mobile las columnas se apilan (una debajo de la otra) -- ahí
    // no hace falta ni conviene alinear alturas.
    if (window.matchMedia('(max-width: 1024px)').matches) {
      card.style.marginTop = '';
      return;
    }
    card.style.marginTop = '';
    const cardRect = card.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    const diff = Math.round(targetRect.top - cardRect.top);
    card.style.marginTop = diff > 0 ? diff + 'px' : '';

    // FixOEM: el margin-top puede "colapsar" parcialmente con el
    // margen inferior del elemento anterior (comportamiento normal de
    // CSS entre hermanos), dejando un pequeño residuo (unos 10px) sin
    // corregir aunque el cálculo de arriba esté bien. Se vuelve a medir
    // DESPUÉS de aplicar el margen y se corrige lo que haya quedado, en
    // vez de asumir que el primer cálculo ya es exacto.
    const cardRectAfter = card.getBoundingClientRect();
    const targetRectAfter = target.getBoundingClientRect();
    const remaining = Math.round(targetRectAfter.top - cardRectAfter.top);
    if (remaining !== 0) {
      const current = parseInt(card.style.marginTop, 10) || 0;
      const corrected = current + remaining;
      card.style.marginTop = corrected > 0 ? corrected + 'px' : '';
    }
  }

  let fixoemAlignPending = false;
  function fixoemScheduleAlign() {
    if (fixoemAlignPending) return;
    fixoemAlignPending = true;
    setTimeout(() => {
      fixoemAlignPending = false;
      fixoemAlignRelatedProductsCard();
    }, 60);
  }
  window.addEventListener('resize', fixoemScheduleAlign);
  // FixOEM: no basta con timeouts fijos -- el widget de disponibilidad
  // por sucursal (".product-single__store-availability-container") es
  // lo que más tarda en cargar (pide datos aparte) y vive FUERA de
  // "#product-info_action_inner", así que cuando terminaba de cargar y
  // empujaba todo hacia abajo, la alineación ya se había calculado y no
  // se volvía a correr -- por eso quedaba disparejo. Se sube el
  // observador a ".product-info_details" (la columna completa de la
  // derecha, que incluye tanto el widget de disponibilidad como el
  // formulario de compra) y se agregan más reintentos con timeouts más
  // largos por si la conexión es lenta.
  [800, 2500].forEach((delay) => setTimeout(fixoemScheduleAlign, delay));
  const fixoemAlignObserverTarget = document.querySelector('.product-info_details');
  if (fixoemAlignObserverTarget && window.MutationObserver) {
    new MutationObserver(fixoemScheduleAlign).observe(fixoemAlignObserverTarget, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style'],
    });
  }

  function fixoemInitRelatedModelProducts() {
    const container = document.getElementById('fixoem-related-model-products');
    if (!container || container.dataset.fixoemInit) return;
    container.dataset.fixoemInit = '1';

    const title = container.getAttribute('data-product-title') || '';
    const currentHandle = container.getAttribute('data-product-handle') || '';
    const query = fixoemExtractModelQuery(title);
    if (!query) return;

    fetch('/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=10' +
      '&resources[options][unavailable_products]=last')
      .then((r) => r.json())
      .then((data) => {
        const products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        fixoemRenderRelatedProducts(container, products, currentHandle);
      })
      .catch(() => {
        container.style.display = 'none';
      });
  }

  const fixoemScheduleRelatedProducts = () => {
    const run = () => fixoemInitRelatedModelProducts();
    if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 2500 });
    else setTimeout(run, 1200);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixoemScheduleRelatedProducts, { once: true });
  } else {
    fixoemScheduleRelatedProducts();
  }

  // app/scripts/product-page.js
  (() => {
    theme.sectionRegister.forEach((item) => {
      switch (item) {
        case "product-template":
          register(item, ProductDefault);
          break;
        case "related-products":
          register(item, RelatedProducts);
          break;
      }
    });
    load("*");
    console.log("product-page.js loaded");
  })();
})();

/* FixOEM: reemplazo real de iconos en la página de producto */
(() => {
  const icon = (body, extra = '') => `<svg class="fixoem-fresh-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" ${extra}>${body}</svg>`;
  const icons = {
    checkCircle: icon('<circle cx="12" cy="12" r="9"></circle><path d="m8 12 2.5 2.5L16.5 8.5"></path>'),
    store: icon('<path d="M3 9l1.5-5h15L21 9"></path><path d="M5 13v7h14v-7"></path><path d="M9 20v-5h6v5"></path><path d="M3 9c0 2 3 3 4.5 1.2C9 12 12 12 13.5 10.2 15 12 18 11 18 9"></path>'),
    shield: icon('<path d="M12 3 20 6v5c0 5-3.3 8.5-8 10-4.7-1.5-8-5-8-10V6l8-3Z"></path><path d="m8.5 12 2.2 2.2 4.8-4.8"></path>'),
    bolt: icon('<path d="m13 2-8 12h7l-1 8 8-12h-7l1-8Z"></path>'),
    truck: icon('<path d="M3 6h11v11H3z"></path><path d="M14 10h4l3 3v4h-7"></path><circle cx="7" cy="18" r="2"></circle><circle cx="17" cy="18" r="2"></circle>'),
    rotate: icon('<path d="M4 8V4m0 0h4M4 4l3 3a7 7 0 1 1-1.7 7"></path>'),
    info: icon('<circle cx="12" cy="12" r="9"></circle><path d="M12 11v5"></path><path d="M12 8h.01"></path>'),
    minus: icon('<path d="M5 12h14"></path>'),
    plus: icon('<path d="M12 5v14M5 12h14"></path>'),
    cart: icon('<circle cx="9" cy="20" r="1.5"></circle><circle cx="18" cy="20" r="1.5"></circle><path d="M3 4h2l2.2 10.2a2 2 0 0 0 2 1.6h7.9a2 2 0 0 0 2-1.6L21 8H6"></path>'),
    bag: icon('<path d="M5 8h14l-1 13H6L5 8Z"></path><path d="M9 9V6a3 3 0 0 1 6 0v3"></path>'),
    tag: icon('<path d="M20 13 13 20 4 11V4h7l9 9Z"></path><circle cx="8.5" cy="8.5" r="1"></circle>'),
    trend: icon('<path d="m4 17 6-6 4 4 6-7"></path><path d="M15 8h5v5"></path>')
  };

  const replace = (selector, markup) => document.querySelectorAll(selector).forEach(el => {
    if (el.dataset.fixoemFreshIcon === '1') return;
    el.outerHTML = markup.replace('<svg ', '<svg data-fixoem-fresh-icon="1" ');
  });

  const refresh = () => {
    const availability = document.querySelectorAll('.pickup-availability-container svg');
    if (availability[0]) availability[0].outerHTML = icons.checkCircle;
    if (availability[1]) availability[1].outerHTML = icons.store;
    if (availability[2]) availability[2].outerHTML = icons.shield;

    const shipping = document.querySelectorAll('.shipping-time .circle svg');
    if (shipping[0]) shipping[0].outerHTML = icons.bolt;
    if (shipping[1]) shipping[1].outerHTML = icons.truck;
    if (shipping[2]) shipping[2].outerHTML = icons.store;

    const guarantees = document.querySelectorAll('.guarantee-inner .guarantee-item > svg');
    if (guarantees[0]) guarantees[0].outerHTML = icons.shield;
    if (guarantees[1]) guarantees[1].outerHTML = icons.rotate;

    replace('.fixoem-branch-note svg', icons.info);
    replace('quantity-input-minus svg', icons.minus);
    replace('quantity-input-plus svg', icons.plus);
    replace('.btn-add-to-cart svg:not(.card-loading)', icons.cart);
    replace('.accelerated-custom svg', icons.bag);
    replace('.fixoem-wholesale-widget_icon svg', icons.tag);
    replace('.fixoem-wholesale-widget_footer svg', icons.trend);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();


/* FixOEM: repetir los cuatro iconos dentro de cada bloque responsive */
(() => {
  const applyResponsiveDeliveryIcons = () => {
    document.querySelectorAll('.shipping-time .container-shipping').forEach(container => {
      const circles = container.querySelectorAll('.column-shipping .circle');
      circles.forEach((circle, index) => {
        const source = document.querySelector('.shipping-time .container-shipping .column-shipping .circle:nth-child(1) svg');
        if (index < 4 && source) {
          const master = document.querySelectorAll('.shipping-time .container-shipping')[0]?.querySelectorAll('.column-shipping .circle')[index]?.querySelector('svg');
          if (master && !circle.querySelector('.fixoem-delivery-icon')) circle.innerHTML = master.outerHTML;
        }
      });
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', applyResponsiveDeliveryIcons, { once: true }) : applyResponsiveDeliveryIcons();
})();

/* FixOEM: iconos frescos para las formas de entrega */
(() => {
  const icons = [
    '<svg class="fixoem-delivery-icon" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#FED700" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" role="img" aria-label="Envío express"><path d="M7 8.5 12 6l5 2.5v6L12 17l-5-2.5z"/><path d="M12 11.5v5.5M7.3 8.7 12 11l4.7-2.3"/><path d="M3 12h2.5M2 15h3.5M4 9h2"/></svg>',
    '<svg class="fixoem-delivery-icon" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#FED700" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" role="img" aria-label="Envío terrestre"><path d="M3 6h11v10H3z"/><path d="M14 9h3.5l3 3v4H14z"/><path d="M17.5 9v3h3"/><circle cx="7" cy="17" r="2"/><circle cx="17.5" cy="17" r="2"/><path d="M9 17h6.5"/></svg>',
    '<svg class="fixoem-delivery-icon" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#FED700" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" role="img" aria-label="Uber en 60 minutos"><path d="M12 21s6-5.2 6-11a6 6 0 1 0-12 0c0 5.8 6 11 6 11z"/><circle cx="12" cy="10" r="2.2"/><path d="M18.5 4.5h3M20 3v3"/></svg>',
    '<svg class="fixoem-delivery-icon" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#FED700" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" role="img" aria-label="Recoge en tienda"><path d="M4 10v10h16V10"/><path d="M3 10 5 4h14l2 6"/><path d="M3 10a2.5 2.5 0 0 0 4.5 1.5A2.5 2.5 0 0 0 12 11.5a2.5 2.5 0 0 0 4.5 0A2.5 2.5 0 0 0 21 10"/><path d="M9 20v-5h6v5"/></svg>'
  ];
  const refreshDeliveryIcons = () => document.querySelectorAll('.shipping-time .container-shipping .column-shipping .circle').forEach((circle, index) => { if (icons[index]) circle.innerHTML = icons[index]; });
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', refreshDeliveryIcons, { once: true }) : refreshDeliveryIcons();
})();


/* FixOEM: iconos correctos por cada bloque de formas de entrega */
(() => {
  const deliveryIcons = [
    '<svg class="fixoem-delivery-icon" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#233F8E" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" role="img" aria-label="Envío express"><path d="M7 8.5 12 6l5 2.5v6L12 17l-5-2.5z"/><path d="M12 11.5v5.5M7.3 8.7 12 11l4.7-2.3"/><path d="M3 12h2.5M2 15h3.5M4 9h2"/></svg>',
    '<svg class="fixoem-delivery-icon" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#233F8E" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" role="img" aria-label="Envío terrestre"><path d="M3 6h11v10H3z"/><path d="M14 9h3.5l3 3v4H14z"/><path d="M17.5 9v3h3"/><circle cx="7" cy="17" r="2"/><circle cx="17.5" cy="17" r="2"/><path d="M9 17h6.5"/></svg>',
    '<svg class="fixoem-delivery-icon" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#233F8E" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" role="img" aria-label="Uber en 60 minutos"><path d="M12 21s6-5.2 6-11a6 6 0 1 0-12 0c0 5.8 6 11 6 11z"/><circle cx="12" cy="10" r="2.2"/><path d="M18.5 4.5h3M20 3v3"/></svg>',
    '<svg class="fixoem-delivery-icon" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#233F8E" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" role="img" aria-label="Recoge en tienda"><path d="M4 10v10h16V10"/><path d="M3 10 5 4h14l2 6"/><path d="M3 10a2.5 2.5 0 0 0 4.5 1.5A2.5 2.5 0 0 0 12 11.5a2.5 2.5 0 0 0 4.5 0A2.5 2.5 0 0 0 21 10"/><path d="M9 20v-5h6v5"/></svg>'
  ];
  const applyDeliveryIconsPerBlock = () => {
    document.querySelectorAll('.shipping-time').forEach(block => {
      if (!block.textContent.includes('Formas de recibir tu pedido')) return;
      block.querySelectorAll('.container-shipping .column-shipping .circle').forEach((circle, index) => {
        if (deliveryIcons[index]) circle.innerHTML = deliveryIcons[index];
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyDeliveryIconsPerBlock, { once: true });
  else applyDeliveryIconsPerBlock();
})();


// FixOEM — mantener una sola pregunta frecuente abierta por producto
(function () {
  function initProductFaqs() {
    document.querySelectorAll('.fx-product-faq').forEach(function (section) {
      if (section.dataset.faqReady === 'true') return;
      section.dataset.faqReady = 'true';
      section.querySelectorAll('details').forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          section.querySelectorAll('details[open]').forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductFaqs);
  } else {
    initProductFaqs();
  }
})();
